import {
  Building2,
  Cog,
  LayoutDashboard,
  Lightbulb,
  Megaphone,
  UserCog,
  Users,
} from 'lucide-react';
import { getMainRoutes } from '@client/shared/utils/routerUtils/routerUtils';

const ROUTES = getMainRoutes();

export const SIDEBAR_ID = 'admin-sidebar';

// The spot in the top bar, opposite the menu button, where a page can put its
// own actions (see NotificationBell).
export const TOP_BAR_ACTIONS_ID = 'admin-top-bar-actions';

export const CREATE_CAMPAIGN_TO = ROUTES.CAMPAIGNS.ROUTES.CREATE.TO;
export const DASHBOARD_TO = ROUTES.DASHBOARD.TO;

// The sections, in the order of the design. Labels follow the design, not the
// legacy route labels. A section is current on its own URL and everything
// beneath it (so Campaigns stays current inside a campaign).
export const MAIN_SECTIONS = [
  {
    key: 'dashboard',
    label: 'Dashboard',
    to: ROUTES.DASHBOARD.TO,
    Icon: LayoutDashboard,
  },
  {
    key: 'campaigns',
    label: 'Campaigns',
    to: ROUTES.CAMPAIGNS.TO,
    Icon: Megaphone,
  },
  {
    key: 'influencers',
    label: 'Influencers',
    to: ROUTES.INFLUENCERS.TO,
    Icon: Users,
  },
  { key: 'admins', label: 'Admins', to: ROUTES.ADMINS.TO, Icon: UserCog },
  {
    key: 'advertisers',
    label: 'Advertisers',
    to: ROUTES.ADVERTISERS.TO,
    Icon: Building2,
  },
  {
    key: 'inspiration',
    label: 'Inspiration',
    to: ROUTES.INSPIRATION.TO,
    Icon: Lightbulb,
  },
];

export const POLICY_LINKS = [
  {
    key: 'child-safety',
    label: 'Child safety policy',
    to: ROUTES.CHILD_SAFETY_POLICY.TO,
  },
  { key: 'privacy', label: 'Privacy policy', to: ROUTES.PRIVACY_POLICY.TO },
];

export const SETTINGS_LINK = {
  key: 'settings',
  label: 'Settings',
  to: ROUTES.SETTINGS.TO,
  Icon: Cog,
};
